import { OrderTypes, ProcessStep } from '../common/enums/enums';

export const isReconditioning = order =>
  order.orderType === OrderTypes.RECONDITIONING ||
  order.orderType === OrderTypes.ESTIMATE;

export const areAllTechniciansAssigned = order =>
  order?.relatedOrders
    ?.filter(
      related =>
        related.step !== ProcessStep.DECLINED &&
        related.step !== ProcessStep.CANCELED
    )
    .every(relatedOrder =>
      relatedOrder.services
        .filter(service => !service.declinedAt)
        .some(service => service.assignee)
    );

export const areAllROAssigned = order =>
  order?.relatedOrders
    ?.filter(
      related =>
        related.step !== ProcessStep.DECLINED &&
        related.step !== ProcessStep.CANCELED
    )
    .every(relatedOrder => relatedOrder.repairOrder);
